import GoogleMap from 'google-maps-react-markers';
import React, { FC, ReactNode } from 'react';

import { googleMapOptions } from './googleMapUtils';
import Marker from './Marker';

export interface GoogleMapsProps {
  lat: number;
  lng: number;
  zoom?: number;
  width: string;
  height: string;
  apiKey: string;
  blockingOverlay?: ReactNode;
}

const GoogleMaps: FC<GoogleMapsProps> = ({
  lat,
  lng,
  zoom = 14,
  height,
  width,
  apiKey,
  blockingOverlay,
}) => {
  return (
    <div style={{ height, width }}>
      {blockingOverlay ? (
        <div className="flex h-full items-center justify-center w-full">
          {blockingOverlay}
        </div>
      ) : (
        <GoogleMap
          apiKey={apiKey}
          defaultCenter={{ lat: lat, lng: lng }}
          defaultZoom={zoom}
          onGoogleApiLoaded={() => null}
          options={googleMapOptions}
        >
          <Marker lat={lat} lng={lng} markerId="Marker" />
        </GoogleMap>
      )}
    </div>
  );
};

export default GoogleMaps;
